import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2, ShieldCheck } from "lucide-react";
import { useAdmin } from "../../lib/admin";
import { formatApiError } from "../../lib/api";
import Seo from "../../components/Seo";

export default function AdminLogin() {
  const { login } = useAdmin();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen grid place-items-center px-6 relative">
      <Seo title="Admin — ASCENDXP" />
      <div className="absolute inset-0 grid-overlay opacity-40" />
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-96 h-96 rounded-full bg-indigo-600/15 blur-[120px]" />
      <form onSubmit={submit} className="relative glass rounded-3xl p-10 w-full max-w-md">
        <div className="w-12 h-12 rounded-xl bg-indigo-600/15 text-indigo-400 grid place-items-center mb-6">
          <ShieldCheck className="w-6 h-6" />
        </div>
        <h1 className="font-heading font-black text-2xl">Admin Console</h1>
        <p className="text-sm text-zinc-500 mt-1">ASCENDXP content & billing management</p>

        {error && <p data-testid="admin-login-error" className="mt-5 text-sm text-red-400 bg-red-500/10 rounded-lg px-4 py-2">{error}</p>}

        <div className="mt-6 space-y-4">
          <input data-testid="admin-email" type="email" required placeholder="Email" className="input-dark"
            value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="admin-password" type="password" required placeholder="Password" className="input-dark"
            value={password} onChange={(e) => setPassword(e.target.value)} />
          <button data-testid="admin-login-btn" disabled={loading} className="btn-primary w-full disabled:opacity-60">
            {loading ? <><Loader2 className="w-5 h-5 animate-spin" /> Signing in…</> : <><Lock className="w-5 h-5" /> Sign In</>}
          </button>
        </div>
      </form>
    </div>
  );
}
